import { render } from "./MonitorStudentDetail.vue?vue&type=template&id=6c15af32&scoped=true"
import script from "./MonitorStudentDetail.vue?vue&type=script&lang=js"
export * from "./MonitorStudentDetail.vue?vue&type=script&lang=js"

import "./MonitorStudentDetail.vue?vue&type=style&index=0&id=6c15af32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c15af32"]])

export default __exports__